/**
 * DetailDateContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Wraps the detail date line and optional catchup row in a column.
 */
const DetailDateContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: ${12 * Screen.widthRatio}px;
  max-width: ${1020 * Screen.widthRatio}px;
  overflow: hidden;
`;

export default DetailDateContainer;
